export enum MsDocContentType {
    Word = 'docx',
    PowerPoint = 'pptx',
    Excel = 'xlsx',
}
export type MsDocAclManagement = 'wiki' | 'unmanaged' | 'unknown';
export type MsDocAccessLevel = 'denied' | 'read_write' | 'read';
